
<template>
  <div style="padding:0 15px;display: flex;flex-direction: column;">
    <div class="box" style="flex:1;height:35vh;display: flex;flex-direction: column;">
      <div class="boxTitle">AEO所在关区</div>
      <div class="boxTitle1">Customs Districts of AEOs</div>
      <div class="echart capsuleChart" style="min-height: 0px;flex:0%;">
        <dv-capsule-chart :config="config3" style="width:100%;height:100%" />

      </div>
    </div>
    <div class="box" style="min-height: 0px;">
      <div class="boxTitle">AEO分布概况</div>
      <div class="boxTitle1">AEO Distribution Overview</div>
      <div class="echart">
        <div id="echart23" style="height:400px;width: 100%;"></div>
      </div>
    </div>
     <div class="bottomBox">{{textBottom.company_data_copy_writing}}</div>
     <div class="bottomBox">{{textBottom.trade_data_copy_writing}}</div>

  </div>

</template>

<script>
  import * as echarts from 'echarts';
  import common from '../../components/api';
	export default {
		name: "eight",
		data() {
      return {
        Chart:null,
        option:{},

        Chart1:null,
        option1:{},
        config3:{
          data: [],
          showValue: true,
          unit: '个',
        },
        configData:[],
        timer:null,
        index:0,
        textBottom:{}
      }
		},
    mounted() {
      this.$axios.post(common.apihost+'/aeo/tradeData/getCustomBasicsScreenDataMap',{}).then(res =>{
        console.log(res.data,888)
        this.textBottom = res.data.data;

      })
      this.$Bus.$on('getCustomCompanyData', e => {
        let data = e.percentageList;
        let arr = [];
        for(let i=0;i<data.length;i++){
          let percentage = (Number(data[i].percentage)*100).toFixed(2)+'%'
          arr.push({ value: data[i].percentage, name: data[i].customName+percentage })
        }
        this.dataInfo2(arr);
        // let rankingListList = e.rankingListList;
        // let seriesData = [];
        // let name = [];
        // for(let i=0;i<rankingListList.length;i++){
        //   name.push(rankingListList[i].customName)
        //   seriesData.push(rankingListList[i].aeoCompanyNum)
        // }
        // this.datainfo(name,seriesData);

        let rankingListList = e.rankingListList;
        let seriesData = [];
        for(let i=0;i<rankingListList.length;i++){
          seriesData.push({value:rankingListList[i].aeoCompanyNum,name:rankingListList[i].customName})
        }
        this.configData = seriesData;
        this.setData();

      })

    },
    methods:{
      setData(){
        clearInterval(this.timer);
        let number = 10;//一行显示的个数
        this.config3.data = this.configData.slice(0, number);
        this.config3 = {...this.config3};
        let length = Math.floor(this.configData.length/number);
        this.index = 0;
        this.timer = setInterval(()=>{
          // console.log(6666)
          if(length>this.index){
            console.log('第',this.index,'页',this.index*number,(this.index+1)*number)
            this.config3.data = this.configData.slice(this.index*number, (this.index+1)*number);
            this.config3 = {...this.config3};
            this.index = this.index+1;
          }else{
            console.log('第',this.index,'页',(this.index-1)*number,this.configData.length)
            this.config3.data = this.configData.slice((this.index-1)*number, this.configData.length);
            this.config3 = {...this.config3};
            this.index = 0;
          }
        },10000);

      },
      handleResize(){
        if (this.Chart) {
          this.Chart.resize()
        }
        if (this.Chart1) {
          this.Chart1.resize()
        }
      },
      dataInfo2(arr){
          this.Chart1 = this.$echarts.init(document.getElementById('echart23'));
          this.option1 = {
                 tooltip: {
                    trigger: 'item'
                  },
                  legend: {
                    x:'center',
                    y:'bottom',
                   textStyle: {
                    "fontSize": 16,
                       color: '#fff' // 设置文字颜色为白色
                   }
                  },
                  series: [
                    {
                      name: 'AEO分布概况',
                      type: 'pie',
                    radius: ['30%', '70%'],
                    center: ['50%', '35%'],
                      avoidLabelOverlap: false,
                      label: {
                        normal: {
                        				show: true,
                                "fontSize": 16,
                        				position: 'inner', // 数值显示在内部
                        				formatter: '{d}%', // 格式化数值百分比输出
                        			},
                        show: false,
                        position: 'right',
                        textStyle: {
                            color: '#fff' // 设置文字颜色为白色
                        }
                      },
                      data: arr
                    }
                  ]
              }
              this.Chart1.setOption(this.option1);
      },
      datainfo(name,seriesData) {

          this.Chart = this.$echarts.init(document.getElementById('echart21'));
          this.option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '9%',
              top: '3%', //默认10%
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: name,
                 axisLine: {
                      lineStyle: {
                          color: '#fff' // 设置 x 轴颜色为红色
                      }
                  },
                axisTick: {
                  alignWithLabel: true
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                splitLine:{
                  show:false
                },
                axisLine: {
                    lineStyle: {
                        color: '#fff' // 设置 y 轴颜色为蓝色
                    }
                },
              }
            ],
            series: [
               {
                name: 'AEO所在关区',
                type: 'bar',
                emphasis: {
                  focus: 'series'
                },
                data: seriesData,
                itemStyle: {
                  emphasis:{
                    barBorderRadius:80
                  },
                  normal:{
                     barBorderRadius:80,
                     color: new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                        {offset:0, color:'#0076F5'},
                        {offset:0.5, color:'#00A1C2'},
                        {offset:1,color:'#00CF88'},
                      ]
                     )
                  },
                },
              }
            ]
          };

          this.Chart.setOption(this.option);

      },
    }
	}

</script>

<style scoped>
  .boxTitle{
    width: 100%;
  }
  .capsuleChart /deep/ .label-column>div{
    font-size:17px!important;
  }
  .capsuleChart /deep/ .capsule-item-value{
    font-size:17px!important;
  }
  .capsuleChart /deep/ .unit-label>div,.capsuleChart /deep/ .unit-text{
    font-size:16px!important;
  }
  .bottomBox{
    height: 40px;
    text-align: left;
    color:#fff;
    font-size: 24px;
    padding:0px;
  }
.echart /deep/ #echart23  div{
    width: 100% !important;
  }
  .echart /deep/ #echart23>div>canvas{
    width: 100% !important;
  }
  .totalText{
    font-size: 20px;
    color:#1AC7FD;
    font-family: '微软雅黑';
        font-weight: 400;
  }
  .totals{
    font-size:28px;
    color:#FFFFFF;
  }
  .rightNumber{
    display: flex;
    align-items: center;
    font-family: '微软雅黑';
    font-weight: 400;
    justify-content: center;
  }
  .imgBox{
    width: 70px;
    height: 70px;
    background: inherit;
    background-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    border-width: 4px;
    border-style: solid;
    border-color: rgba(49, 167, 255, 1);
    border-radius: 188px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    color: #FFFFFF;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .imgBox img{
    width: 42px;
    height: 42px;
  }
  .numberText{
    border-width: 0px;
    width: 240px;
    height: 100px;
    background: inherit;
    background-color: rgba(26, 201, 255, 0.298039215686275);
    border: none;
    border-top: 0px;
    border-right: 0px;
    border-bottom: 0px;
    border-radius: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    text-align: left;
    margin-left:15px;
    padding:15px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/rightNew/rightTwo.vue